













import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import {
  $folders,
  clearFields,
  foldersDropdownModule,
  loadFolders,
  setSelectedFolder,
} from '@/pages/common/dropdowns/bank/lesson-tasks/position-dropdown/position-dropdown.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    $folders,
    ...foldersDropdownModule.store,
  },
  methods: {
    loadFolders,
    ...foldersDropdownModule.methods,
    onSelectItem(item: DropdownItem | null) {
      setSelectedFolder(item)
      this.$emit('setItem', item ? item.name : null)
    },
  },
  mounted() {
    loadFolders()
  },
  beforeDestroy() {
    clearFields()
  },
})
